import { LocationComplianceDeviationReason, NotificationEvent } from '@caresend/types';
import { getNotificationTimeInfo, getNotificationLicensedUserInfo } from '@caresend/utils';
import { defineComponent } from 'vue';
import Warning from '../../../assets/icons/warning-2.svg.js';
import __vue_component__$2 from '../../alerts/Pane/Pane.vue.js';
import __vue_component__$1 from '../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__ from '../../cards/BasicCard/BasicCard.vue.js';
import { trackNotificationEventRequest } from '../../../database/firebaseConfig/cloudFunctions.js';
import '../portal/store/portal/sessionStore.js';
import 'file-saver';
import '../../../database/encryption/model.js';
import 'js-sha256';
import { getStore } from '../../../store/helpers/initStore.js';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../portal/store/storeUtilities/dbSync/dbSyncStore.js';
import '../../../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../database/firebaseConfig/init.js';
import '../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'immutability-helper';
import '../../../router/routes/dev/model.js';
import '../../../router/routes/dev/routes.js';
import '../../../router/routes/dashboard/model.js';
import '../../../router/routes/pro/model.js';
import '../../../router/routes/visitsPage/model.js';
import '../../../router/routes/orderFlow/model.js';
import '../../../router/routes/orderFlow/privateHelpers.js';
import '../../../router/routes/orderFlow/routes.js';
import '../../../router/routes/schedulingFlow/model.js';
import '../../../router/routes/schedulingFlow/routes.js';
import '../../../router/routes/chartingFlow/model.js';
import '../../../router/routes/chartingFlow/routes.js';
import '../../../router/routes/portal/portalRoutes.js';
import '../../../router/routes/portal/model.js';
import '../../../router/routes/visitsPage/routes.js';
import '../dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../store/modules/chartingFlow/model.js';
import '../../../store/modules/office/index.js';
import '../VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../store/modules/office/model.js';
import '../../../store/modules/orderFlow/index.js';
import '../../../store/modules/procedures/model.js';
import '../../../store/modules/schedulingFlow/index.js';
import '../../../store/modules/schedulingFlow/model.js';

const deviationReasons = {
    [LocationComplianceDeviationReason.NO_AVAILABLE_PARKING]: 'No available parking',
    [LocationComplianceDeviationReason.INCORRECT_ADDRESS]: 'Incorrect address on app',
    [LocationComplianceDeviationReason.UNCLEAR_INSTRUCTIONS]: 'Unclear instructions',
};
var script = defineComponent({
    /** Capture why the clinician is too far from the waypoint location */
    name: 'LocationDeviationReasonModal',
    components: {
        BasicCard: __vue_component__,
        ButtonComponent: __vue_component__$1,
        Pane: __vue_component__$2,
        Warning,
    },
    props: {
        isOpened: Boolean,
        waypointID: {
            type: String,
            required: true,
        },
    },
    setup(props, { emit }) {
        const store = getStore();
        const handleKeepDriving = async () => {
            var _a, _b;
            const waypoint = store.getters['waypoint/getWaypointByID'](props.waypointID);
            const staffingOfficeName = (_a = store.getters['waypoint/getStaffingOfficeByWaypointID'](props.waypointID)) === null || _a === void 0 ? void 0 : _a.info.name;
            const shiftID = store.getters['waypoint/getShiftIDByWaypointID'](props.waypointID);
            const timeInfo = ((_b = waypoint === null || waypoint === void 0 ? void 0 : waypoint.transitInfo) === null || _b === void 0 ? void 0 : _b.arrivalTime)
                ? getNotificationTimeInfo(waypoint.transitInfo.arrivalTime)
                : undefined;
            const nurse = store.getters['waypoint/getNurseByWaypointID'](props.waypointID);
            if (!nurse) {
                throw new Error(`Nurse not found for waypoint ${props.waypointID} when tracking waypoint arrival blocker`);
            }
            trackNotificationEventRequest({
                event: NotificationEvent.WAYPOINT_ARRIVAL_BLOCKER,
                data: {
                    nurse: getNotificationLicensedUserInfo(nurse),
                    staffingOfficeName,
                    shiftID,
                    itineraryID: waypoint === null || waypoint === void 0 ? void 0 : waypoint.itineraryID,
                    timeInfo,
                },
                recipients: [nurse === null || nurse === void 0 ? void 0 : nurse.id],
            });
            emit('close');
        };
        const captureDeviationReason = (reason) => {
            emit('selectDeviationReason', reason);
        };
        return {
            captureDeviationReason,
            deviationReasons,
            handleKeepDriving,
        };
    },
});

export { script as default };
